import { Box, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { useContext } from 'react';
import { AuthContext } from '@/store';
import UserAvatar from '@/components/ui/userAvatar';

const useStyles = (theme) => ({
  selfMargins: {
    marginBottom: '0.7rem !important',
    paddingLeft: '5rem !important',
  },
  margins: {
    marginBottom: '0.7rem !important',
    paddingRight: '2rem !important',
  },
  avatar: {},
  avatarButton: {
    padding: '10px !important',
    paddingLeft: '0px !important',
  },
  textFormat: {
    whiteSpace: 'pre-wrap !important',
  },
  userNameHolder: {
    height: '17px !important',
    lineHeight: '13px !important',
  },
  userName: {
    textTransform: 'capitalize !important',
    fontSize: '10px !important',
    padding: '0px !important',
    height: '17px !important',
    color: `${theme.palette.text.secondary} !important`,
    opacity: '0.8 !important',
    '&:hover': {
      opacity: '1 !important',
      textDecoration: 'underline !important',
    },
  },
  chatHolder: {
    width: '100% !important',
    overflowX: 'auto !important',
    overflowY: 'hidden !important',
  },
  chatText: {
    position: 'relative !important',
    backgroundColor: `${theme.palette.background.shadedown_10} !important`,
    borderRadius: '1rem !important',
    borderBottomLeftRadius: '0px !important',
    padding: '1rem !important',
  },
  selfChatText: {
    width: '100% !important',
    overflowX: 'auto !important',
    position: 'relative !important',
    backgroundColor: `${theme.palette.background.shadedown_10} !important`,
    borderRadius: '1rem !important',
    borderBottomRightRadius: '0px !important',
    padding: '1rem !important',
    marginRight: '5px !important',
  },
});

const ThreadMessageBubble = (props) => {
  const { authState } = useContext(AuthContext);
  const theme = useTheme();
  const classes = useStyles(theme);

  return props.message.visitorId === authState.user.id ? (
    <Box sx={classes.selfMargins}>
      <Box display="flex" alignItems="flex-end">
        <Box sx={classes.selfChatText} flexGrow={1}>
          <Typography variant="body2" sx={classes.textFormat}>
            {props.message.tempText
              ? `${props.message.tempText}...`
              : props.message.text}
          </Typography>
        </Box>
      </Box>
    </Box>
  ) : (
    <Box sx={classes.margins}>
      <Box display="flex" alignItems="flex-end">
        <Box>
          <Box sx={classes.avatarButton}>
            <UserAvatar size="small" user={props.message.visitor} />
          </Box>
        </Box>
        <Box flexGrow={1} sx={classes.chatHolder}>
          <Box sx={classes.chatText}>
            <Typography variant="body2" sx={classes.textFormat}>
              {props.message.text}
            </Typography>
          </Box>
          <Box sx={classes.userNameHolder}>
            <Button
              sx={classes.userName}
              component="a"
              onClick={() => props.openParticipant(props.message.visitor)}
            >
              {props.message.visitor.full_name}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
export default React.memo(ThreadMessageBubble, () => {
  return true;
});
